import type { Environment } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

export const FEEDBACK_GROUP_ID = 'jira-list-view-migration-feedback';
export const NO_DO_NOT_MIGRATE_VALUE = 'do-not-migrate-me';
export const YES_PLEASE_MIGRATE_VALUE = 'yes';
export const DID_NOT_RESPOND_VALUE = 'no-response';
export const FEEDBACK_CONTEXT_FIELD_ID = 'customfield_10047';

/* EP MESSAGE */
export const MIGRATION_FEEDBACK_MSG_ENGAGEMENT_ID_STG = 'jira-list-migration-feedback';
export const MIGRATION_FEEDBACK_MSG_ENGAGEMENT_ID_PROD = 'jira-list-migration-feedback-prd'; // TODO: Create EP prod msg

export const ENV_STAGING: Environment = 'staging';
export const STARGATE_URL = '/gateway/api';
